import { Button, EmptyState, Icons } from "@dms/ui";
import { useNavigate } from "react-router-dom";

// 12-screen-spec §14 (404).
export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div style={{ paddingTop: 40 }}>
      <EmptyState
        icon={<Icons.search size={26} />}
        title="Сторінку не знайдено"
        description="Можливо, посилання застаріле або сторінку переміщено."
        action={<Button onClick={() => navigate("/dashboard")}>На панель</Button>}
      />
    </div>
  );
}
